
const initialState = {
    isMobile:false,
    isRtl:true,
    lang:"fa-IR",
    activeTab: "SearchResidence",
    fixed: false,
    showSearchBox: false,
    startDate:"",
    endDate:"",
    guestsList: "",
    guests : [
      {
          title:"Adult",
          description:"Over13",
          count:0
      },
      {
          title:"Child",
          description:"Under13",
          count:0
      }
  ] ,
  searchArea:"",
  propertyType:"",
  propertyListing:"",
  activeIndex : 0,
  minPrice:0,
  maxPrice:100,
  currencyRatio:"میلیون تومان"
    
};

export const mainReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ISMOBILE":
      return {
        ...state,
        isMobile: action.value.val,
      };
    case "SET_ISRTL":
      return {
        ...state,
        isRtl: action.value.val,
      };
    case "SET_LANG":
      return {
        ...state,
        lang: action.value.val,
      };
    case "CHANGE_ACTIVE_TAB":
      return {
        ...state,
        activeTab: action.value.val,
      };
    case "SET_FIXED":
      return {
        ...state,
        fixed: action.value.val,
      };
    case "SET_SHOW_SEARCH_BOX":
    return {
      ...state,
      showSearchBox: action.value.val,
    };
    case "SET_START_DATE":
      return {
        ...state,
        startDate: action.value.val,
      };
    case "SET_END_DATE":
      return {
        ...state,
        endDate: action.value.val,
      };
      
    case "SET_GUESTS_LIST":
      return {
        ...state,
        guestsList: action.value.val,
      };
    case "CHANGE_GUEST_COUNT":
      return {
        ...state,
        guests: [
          ...state.guests.slice(0,action.value.index),
          {
              
              ...state.guests[action.value.index],
              count : action.value.tempCount
          },
          ...state.guests.slice(action.value.index+1) 
      ]
      };
    case "SET_PROPERTYTYPE":
      return {
        ...state,
        propertyType: action.value.val,
      };
    case "SET_PROPERTYLISTING":
      return {
        ...state,
        propertyListing: action.value.val,
      };
    case "SET_SEARCH_AREA":
      return {
        ...state,
        searchArea: action.value.val,
      };
    case "SET_ACTIVE_INDEX":
      return {
        ...state,
        activeIndex: action.value.val,
      };
    case "SET_MIN_PRICE":
      return {
        ...state,
        minPrice: action.value.val,
      };
    case "SET_MAX_PRICE":
      return {
        ...state,
        maxPrice: action.value.val,
      };
      
    case "SET_CURRENCY_RATIO":
      return {
        ...state,
        currencyRatio: action.value.val,
      };
    default:
      return state;
  }
};


